<template>
  <div>
    <div class="text-muted small">{{activity.created_at | formatRelativeDate}}</div>
    <!--USER LINK-->
    <UserLink :user="activity.causer"/>

    <!--ACTIVITY LOG ACTION-->
    {{ $t('actions.' + $options.filters.slugify(activity.description)) }}

    <!--CREATED-->
    <div v-if="activity.description === 'added'">
      <div v-if="activity.subject">
        <span> {{ $t('activities.third_party.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.third_party.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('activities.log.title') }}</span>
        <router-link
                :to="{ name: 'activities.view', params: { slug: activity.subject.activity.slug }}"
        >
            {{activity.properties.activity.name}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('activities.third_party.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.third_party.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('activities.log.title') }}</span>
        <router-link
                :to="{ name: 'activities.view', params: { slug: activity.properties.activity.slug }}"
        >
            {{activity.properties.activity.name}}
        </router-link>
      </div>
    </div>

    <!--DELETED-->
    <div v-if="activity.description === 'removed'">
      <div v-if="activity.subject">
        <span> {{ $t('activities.third_party.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.third_party.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('activities.log.title') }}</span>
        <router-link
                :to="{ name: 'activities.view', params: { slug: activity.subject.activity.slug }}"
        >
            {{activity.properties.activity.name}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('activities.third_party.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.third_party.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('activities.log.title') }}</span>
        <router-link
                :to="{ name: 'activities.view', params: { slug: activity.properties.activity.slug }}"
        >
            {{activity.properties.activity.name}}
        </router-link>
      </div>
    </div>

    <!--UPDATED-->
    <div v-if="activity.description === 'updated'">
      <div v-if="activity.subject">
        <span> {{ $t('activities.third_party.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.third_party.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('activities.log.title') }}</span>
        <router-link
                :to="{ name: 'activities.view', params: { slug: activity.subject.activity.slug }}"
        >
            {{activity.properties.attributes.activity.name}}
        </router-link>
      </div>

      <div v-else>
        <span> {{ $t('activities.third_party.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.attributes.third_party.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('activities.log.title') }}</span>
        <router-link
                :to="{ name: 'activities.view', params: { slug: activity.properties.attributes.activity.slug }}"
        >
            {{activity.properties.attributes.activity.name}}
        </router-link>
      </div>

      <div v-if="changes">
        <div class="mt-2 small">
          <span class="text-warning text-bold">
            {{ $t('activities.log.changes')}}
          </span>
        </div>
        <div v-for="(item, index) in activity.properties.attributes">
          <div v-if="item !== activity.properties.old[index]">
            <span class="small" v-if="!isObject(item)">
              <span class="text-bold">{{makeTitle(index)}}</span>
              <span> has been changed to </span>
              <span v-if="index === 'updated_at'" class="text-bold">
                {{item | formatDate}}
              </span>
              <span v-else class="text-bold">{{item}}</span>
            </span>
          </div>
          <div class="small mt-2" v-if="index === 'data_objects'">
            <div v-for="data in removedData(activity.properties)" class="mb-1">
              <span>
                <span class="badge badge-info p-1">
                  {{data.name}}
                </span>
                {{ $t('activities.log.data_object_removed')}}
              </span>
            </div>
            <div v-for="data in addedData(activity.properties)" class="mb-1">
              <span>
                <span class="badge badge-info p-1">
                  {{data.name}}
                </span>
                {{ $t('activities.log.data_object_added')}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';

  export default {
    name: 'ActivityThirdParty',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
      }
    },
    props: {
      activity: {},
      changes: false
    },
    components: {
      UserLink
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }

        }

        return words.join(' ');
      },
      removedData: function (properties) {

        let results = [];

        for (var i = 0; i < properties.old.data_objects.length; i++) {

          let removed = true;

          for (var j = 0; j < properties.attributes.data_objects.length; j++) {

            if (properties.old.data_objects[i].id === properties.attributes.data_objects[j].id) {
              removed = false;
            }
          }

          if (removed) {
            results.push(properties.old.data_objects[i]);
          }

        }

        return results
      },
      addedData: function (properties) {
        let results = [];

        for (var i = 0; i < properties.attributes.data_objects.length; i++) {

          let added = true;

          for (var j = 0; j < properties.old.data_objects.length; j++) {

            if (properties.attributes.data_objects[i].id === properties.old.data_objects[j].id) {
              added = false;
            }
          }

          if (added) {
            results.push(properties.attributes.data_objects[i]);
          }

        }

        return results
      }
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
